import * as React from 'react';

import { Box, Collapse, StyleSheet, color, css, font, spacing } from '@coursera/coursera-ui';
import { SvgChevronRight } from '@coursera/coursera-ui/svg';

import { expiredFaqs } from 'bundles/enterprise-admin-home/components/ExpiredFaqsUtils';

import _t from 'i18n!nls/enterprise-admin-home';

const styles = StyleSheet.create({
  background: {
    background: 'var(--cds-color-neutral-background-primary-weak)',
    width: '100%',
    minHeight: '350px',
    position: 'relative',
    zIndex: 0,
    overflow: 'hidden',
  },
  backgroundPattern: {
    position: 'absolute',
    top: 0,
    left: 0,
    zIndex: '-100',
    overflow: 'initial',
  },
  title: {
    fontWeight: '600',
    marginTop: spacing.xl,
    marginBottom: spacing.md,
    textAlign: 'center',
  },
  faqContainer: {
    listStyleType: 'none',
    margin: `0 auto ${spacing.xxl}`,
    maxWidth: '754px',
    zIndex: '1000',
  },
  faqQuestion: {
    background: color.white,
    cursor: 'pointer',
    width: '100%',
    display: 'block',
    padding: `${spacing.md} ${spacing.md}`,
    margin: `${spacing.sm} 0px 0px`,
  },
  faqQuestionFont: {
    fontSize: '16px !important',
  },
  faqAnswer: {
    background: color.white,
    textAlign: 'left',
    padding: `${spacing.sm} ${spacing.xl} ${spacing.sm} ${spacing.xl}`,
    fontSize: font.md,
  },
});

export default function ExpiredFaq() {
  return (
    <div {...css(styles.background)}>
      <h3 {...css(styles.title)}>{_t('FAQs')}</h3>
      <div {...css('rc-Faqs', styles.faqContainer)}>
        <Collapse rootClassName={styles.faqContainer} isAccordion>
          {expiredFaqs().map((faq) => (
            <Collapse.Panel
              key={faq.id}
              id={faq.id}
              renderHeader={({ isExpanded }) => (
                <Box alignItems="center" rootClassName={styles.faqQuestion}>
                  <SvgChevronRight
                    style={{ transform: isExpanded ? 'rotate(90deg)' : 'rotate(0deg)' }}
                    color={color.primary}
                  />
                  <span {...css('p-l-1s', styles.faqQuestionFont)}>{faq.question}</span>
                </Box>
              )}
              renderChildren={({ isExpanded }) =>
                isExpanded ? <div {...css(styles.faqAnswer)}>{faq.answer}</div> : null
              }
            />
          ))}
        </Collapse>
      </div>
    </div>
  );
}
